import { useShowResultsButton } from '../hooks'

const ShowResultsButton = ({ mapId }) => {
  const [visible, { onClick }] = useShowResultsButton(mapId)
  if (visible) {
    return (
      <button key="button" className="map--back-to-results" onClick={onClick}>results</button>
    )
  } else {
    return null
  }
}

export default ShowResultsButton